import EmotionChart from './EmotionChart';

interface IntroEmotionsScreenProps {
  onNext: () => void;
}

export default function IntroEmotionsScreen({ onNext }: IntroEmotionsScreenProps) {
  return (
    <div
      className="flex flex-col w-full h-screen"
      style={{
        background: 'linear-gradient(170deg, #1A1B2E 0%, #2D1B3D 60%, #1F1A35 100%)',
        overflowY: 'auto',
        overflowX: 'hidden',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      {/* Progress dots */}
      <div className="flex justify-center gap-2 pt-12 pb-4">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            style={{
              width: i === 1 ? '20px' : '6px', height: '6px',
              borderRadius: '3px',
              background: i <= 1 ? '#3ECFA0' : 'rgba(255,255,255,0.2)',
            }}
          />
        ))}
      </div>

      {/* Icon */}
      <div className="flex justify-center pt-8 pb-4">
        <div
          style={{
            width: '80px', height: '80px',
            borderRadius: '24px',
            background: 'rgba(139,122,184,0.12)',
            border: '1px solid rgba(139,122,184,0.25)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <i className="ri-emotion-line text-4xl" style={{ color: '#8B7AB8' }} />
        </div>
      </div>

      {/* Text */}
      <div className="px-7 mb-6">
        <p style={{ fontSize: '20px', fontWeight: 700, color: '#F5F5F7', lineHeight: 1.4, marginBottom: '10px' }}>
          Эмоциональный анализ
        </p>
        <p style={{ fontSize: '15px', fontWeight: 400, color: '#A8B2C8', lineHeight: 1.7 }}>
          Каждое сохранённое воспоминание анализируется через эмоции: радость, печаль, страх и гнев.
        </p>
      </div>

      {/* Chart */}
      <div className="px-5 flex-1">
        <EmotionChart />
      </div>

      {/* Button */}
      <div
        className="px-7 pt-4"
        style={{ paddingBottom: 'calc(32px + env(safe-area-inset-bottom))' }}
      >
        <button
          onClick={onNext}
          className="w-full active:scale-95 transition-transform duration-150"
          style={{
            height: '56px', borderRadius: '28px',
            background: 'linear-gradient(135deg, #3ECFA0, #2BA87F)',
            border: 'none', fontSize: '17px', fontWeight: 600, color: '#fff',
            cursor: 'pointer', boxShadow: '0 8px 24px rgba(62,207,160,0.35)',
          }}
        >
          Далее
        </button>
      </div>
    </div>
  );
}
